import React from 'react'

import Navbar from 'react-bootstrap/Navbar'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'





function NavigationBar() {
    return (
      <React.Fragment>

          


        <Navbar bg="dark" expand="lg" variant="dark">
        <Navbar.Brand href="/">Home</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
          <Nav.Link href="/about">About</Nav.Link>
            <Nav.Link href="/contact">Contact me</Nav.Link>
            <Nav.Link href="/pricing">Pricing</Nav.Link>
            
            <NavDropdown title="Dropdown" id="basic-nav-dropdown">
              <NavDropdown.Item href="/action">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
            </NavDropdown>
          </Nav>
          <Form inline>
          <Nav >
              <Nav.Link className="signup" href='/signup'>Sign Up</Nav.Link>
              <Nav.Link className="signin" href='/signin'>Sign In</Nav.Link>
          </Nav>
            
            <FormControl type="text" placeholder="Search" className="mr-sm-2" />
            <Button variant="outline-success">Search</Button>

           

          </Form>
        </Navbar.Collapse>
        </Navbar>
      </React.Fragment>

        
    )
}

export default NavigationBar
